/* eslint-disable */
import React, {Component} from 'react';
import {Alert} from 'react-bootstrap';
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle';

import './error-messages.css';

class ErrorMessages extends Component {
  constructor(props) {
    super(props);
    
    const regex = /{{(\s\d+\s)}}/g;
    const str = this.props.children;
    let m,
      countdown;
    
    while ((m = regex.exec(str)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      
      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        if (groupIndex === 1) {
          countdown = +match;
        }
      });
    }
    
    this.tick = this.tick.bind(this);
    let message = props.children;
    
    if (countdown) {
      this.timer = setInterval(this.tick, 1000);
      message = props.children.replace(/{{(\s.+\s)}}/g, this.parseTime(countdown));
    }
    
    this.state = {
      login: {
        countdown
      },
      children: message
    };
  }
  
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  
  parseTime(time) {
    let minutes = Math.floor(time / 60);
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    let seconds = time % 60;
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    
    return `${minutes}:${seconds}`;
  }
  
  tick() {
    const time = this.state.login.countdown - 1;
    if (time === 0) {
      clearInterval(this.timer);
    }
    
    const counterMessage = this.state.children.replace(/\d{2}:\d{2}/g, this.parseTime(time));
    
    this.setState({
      login: {
        countdown: time,
      },
      children: counterMessage
    });
  }
  
  render() {
    return (
      // <Panel className="errors" bsStyle="danger">
      <Alert bsStyle="danger" className="notiny-animation-show">
        <FaExclamationTriangle size={15} className="icon-shake"/>
        <span className="error-message" dangerouslySetInnerHTML={{__html: this.state.children}}/>
      </Alert>
    );
  }
}

export default ErrorMessages;



// WEBPACK FOOTER //
// ./src/components/login/error-messages.jsx